import { Checkbox, List, ListItem, ListItemText } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import { TextColorStyleClasses } from 'assets/jss/common-styles';
import BoxDrawer from 'components/BoxDrawer';
import ButtonConfirmAndClose from 'components/Buttons/ButtonConfirmAndClose';
import { SpinnerIndicator } from "components/CallServer";
import MuiPaper from 'components/MuiExtras/MuiPaper';
import SystemRoleName from 'components/Translations/SystemRoleName';
import { SystemRoles, GroupType } from 'models/ApiEnums';
import { SelectableGroupShortView } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: SelectableGroupShortView[];
}

interface IProps {
    groups: string[];
    role: SystemRoles;
    onClose: (groups: SelectableGroupShortView[]) => void;
}

type Props = IProps & WithStyles<typeof TextColorStyleClasses> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class UserGroupsWithPermissionsDrawer extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
        };
    }

    ///
    private getGroups() {
        api.getUserSimulatedGroupsWithPermission(this.props.groups, this.props.role)
            .then((data) => {
                this.setState({ data: data.map((v) => ({ checked: true, id: v.id, name: v.name, thumbnailUrl: v.thumbnailUrl, groupType: v.groupType } as SelectableGroupShortView)) });
            });
    }

    ///
    private renderForm() {
        return (
            <List>
                {
                    this.state.data.map((v) => (
                        <ListItem
                            key={v.id}
                            dense
                            disableGutters
                        >
                            <Checkbox
                                checked={v.checked}
                                disabled={v.groupType == GroupType.SystemAllUsers}
                                onClick={
                                    () => this.setState(state => {
                                        const item = state.data.find(x => x.id == v.id);
                                        item.checked = !item.checked;
                                        return state;
                                    })
                                }
                                style={{ padding: 0 }}
                            />
                            <ListItemText
                                primary={v.name}
                            />
                        </ListItem>
                    ))
                }
            </List>
        );
    }

    ///
    public componentDidMount() {
        this.getGroups();
    }

    ///
    public render() {
        const { role, onClose } = this.props;

        return (
            <BoxDrawer
                open={true}
                title={<SystemRoleName role={role} />}
                subtitle={this.props.t("Views.User.Dialogs.UserGroupsWithPermissionsDrawer.BoxSubtitle")}
                onClose={() => { onClose(null); }}
            >
                <MuiPaper dense elevation={0}>
                    {
                        this.state.data == null
                            ? <SpinnerIndicator />
                            : this.renderForm()
                    }

                    <ButtonConfirmAndClose
                        fullWidth
                        onClick={() => { this.props.onClose(this.state.data); }}
                    />
                </MuiPaper>

            </BoxDrawer>
        );
    }
}

export default withTranslation()(withStyles(TextColorStyleClasses)(UserGroupsWithPermissionsDrawer));